import { cn } from '@/lib/utils';

const seliseLogo = '/assets/images/selise-hr-logo.svg';

type LoginSeliseLogoProps = {
  className?: string;
  variant?: 'default' | 'hero';
};

export const LoginSeliseLogo = ({ className, variant = 'default' }: LoginSeliseLogoProps) => {
  return (
    <img
      src={seliseLogo}
      alt="SELISE digital platforms"
      className={cn(
        'h-10 w-auto shrink-0 object-contain object-left',
        variant === 'hero' && 'relative z-10',
        className
      )}
    />
  );
};
